import { BaseSerializer } from "./baseSerializer.ts";
import { FileSummary } from "../fileSummary.model.ts";


export class FileSummarySerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new FileSummary();

        this._copyAttributes(gp, data);

        return gp;

    }

}
